import scrollImg2 from "./../images/ROH_NEW_SCROLL.webp"

function ScrollLoader() {
  return (
    <div className="scroll-page">
      <div className="scroll-overlay" />

      <div
        className="scroll-loader"
        style={{ "--scroll-image": `url(${scrollImg2})` }}
      >
        <div className="scroll-cloth"></div>

        <div className="scroll-roll scroll-roll-left"></div>
        <div className="scroll-roll scroll-roll-right"></div>

        {/* <div className="scroll-text">...</div> */}

        <div className="scroll-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  )
}

export default ScrollLoader
